import React from "react";
import LoginSection from "../../components/employees/Login";

const LoginPage = ({ setIsLoggedIn }) => {
  return (
    <div className="commom-001">
      <LoginSection setIsLoggedIn={setIsLoggedIn} />
    </div>
  );
};

export default LoginPage;
